import React from 'react';
import { createIcon } from '../../../utils';

const IconBellFilled = createIcon({
  viewBox: '0 0 17 16',
  path: (
    <path
      d="M13.42 9.58667C13.5512 9.71803 13.6552 9.87396 13.7261 10.0455C13.7971 10.2171 13.8335 10.401 13.8333 10.5867C13.8333 10.9615 13.6844 11.321 13.4194 11.586C13.1543 11.8511 12.7948 12 12.42 12H4.57999C4.20515 12 3.84566 11.8511 3.58061 11.586C3.31556 11.321 3.16666 10.9615 3.16666 10.5867C3.16649 10.401 3.20291 10.2171 3.27383 10.0455C3.34476 9.87396 3.44879 9.71803 3.57999 9.58667L4.49999 8.66667V6C4.49999 4.93913 4.92142 3.92172 5.67156 3.17157C6.42171 2.42143 7.43912 2 8.49999 2C9.56086 2 10.5783 2.42143 11.3284 3.17157C12.0786 3.92172 12.5 4.93913 12.5 6V8.66667L13.42 9.58667ZM10.5 12H6.49999C6.49999 12.5304 6.7107 13.0391 7.08578 13.4142C7.46085 13.7893 7.96956 14 8.49999 14C9.03042 14 9.53913 13.7893 9.9142 13.4142C10.2893 13.0391 10.5 12.5304 10.5 12Z"
      fill="#CFDAEC"
      stroke="#0D47A1"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
});

export default IconBellFilled;
